import { Accordion } from '@bw/elements';
import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { RichText } from '../../utils/rich-text/RichText';
import styles from './AccordionSection.module.scss';

export const AccordionSection: Block<'accordion'> = ({
	data: {
		fields: { title, items, description },
	},
	fieldId,
}) => {
	return (
		<section className={styles.accordion} {...fieldId('.')}>
			{title && (
				<div className={styles.title} {...fieldId('title')}>
					{title}
				</div>
			)}
			{description && (
				<div className={styles.description} {...fieldId('description')}>
					<RichText document={description} />
				</div>
			)}
			{items && (
				<Accordion
					items={items
						.filter((item) => item != undefined)
						.map((item) => ({
							title: (
								<span {...annotate(item, 'title')}>
									<RichText document={item.fields.title} />
								</span>
							),
							body: <RichText document={item.fields.text} />,
						}))}
				/>
			)}
		</section>
	);
};
